import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { useEffect, useState } from "react";
import { DownloadIcon, FileIcon } from "src/components/ui-icons/upload";
import { selectItem, selectItems } from "src/modules/spItems/selectors";
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import moment from "moment";
import { getItem, getItems } from "src/modules/spItems/actions";
import { selectUsers } from "src/modules/users/selector";
import { documentByCardFilesLibName, equipmentsListName, myDocumentsListName, siteUrl, versionsByDocumentListName } from "src/api/config";
import { siteUrlOrSiteApi } from "src/api/config/systemSwitch";

type Props = {
    JsomHistoryFields: string;
}

const HistoryChanges = (props: Props) => {

    const { JsomHistoryFields } = props;
    const [show, setShow] = useState(false);
    const [fieldsChanges, setFieldChanges] = useState<any>({});
    const dispatch = useAppDispatch();
    const users: any = useAppSelector(selectUsers);

    useEffect(() => {
        if (JsomHistoryFields) {
            const tempHistoryFieldsChanges = JSON.parse(JsomHistoryFields);
            setFieldChanges(tempHistoryFieldsChanges);
        }
    }, [JsomHistoryFields]);

    const downLoadHandle = (e: any, url: string, name: string) => {
        e.preventDefault();
        fetch(`${siteUrlOrSiteApi + encodeURI(url)}`).then((response) => response.blob()).then((blob) => {
            const printFile = new File([blob], name, {
                type: blob.type,
                lastModified: moment().unix(),
            });
            let reader = new FileReader();
            reader.readAsDataURL(printFile);
            reader.onload = function () {
                const src = reader.result;
                const linkDownLoad: HTMLAnchorElement = document.createElement("a");
                linkDownLoad.setAttribute("download", printFile.name);
                // @ts-ignore
                linkDownLoad.setAttribute("href", src);
                linkDownLoad.style.display = "none";
                document.body.appendChild(linkDownLoad);
                linkDownLoad.click();
                document.body.removeChild(linkDownLoad);
            };
        });
    }

    return (
        <div className="w-full">
            {Object.keys(fieldsChanges).length > 0 &&
                <>
                    <div onClick={() => setShow(!show)} className="text-sm flex items-center mb-6 cursor-pointer">
                        {!show &&
                            <>
                                <ArrowDown />&nbsp;&nbsp;<span>Показать изменения</span>
                            </>
                            ||
                            <>
                                <ArrowUp />&nbsp;&nbsp;<span>Скрыть изменения</span>
                            </>
                        }
                    </div>
                    {show &&
                        <div className="flex gap-5 flex-col">
                            {Object.keys(fieldsChanges).map((keyField: string) => (
                                <>
                                    {keyField === 'CommentFiles' &&
                                        <> <div className="text-sm flex items-center">
                                            <span>Файлы:&nbsp;</span>
                                            {Object.keys(fieldsChanges[keyField]).map((key: string) => (
                                                <>
                                                    {key === 'old' && fieldsChanges[keyField][key] && fieldsChanges[keyField][key].length > 0 && fieldsChanges[keyField][key].map((file: any, idx: number) => (
                                                        <>
                                                            <span className="text-[#BA0C2F] line-through">{file.url && file.url.split('/')[file.url.split('/').length - 1] || file.FileRef.split('/')[file.FileRef.split('/').length - 1]}</span>{idx + 1 !== fieldsChanges[keyField][key].length && ',' || ''}&nbsp;
                                                        </>
                                                    ))}
                                                    {key === 'new' && fieldsChanges[keyField][key] && fieldsChanges[keyField][key].length > 0 && fieldsChanges[keyField][key].map((file: any, idx: number) => (
                                                        <>
                                                            <span className="text-[#22AD5C]">{file.url && file.url.split('/')[file.url.split('/').length - 1] || file.FileRef.split('/')[file.FileRef.split('/').length - 1]}</span>{ }{idx + 1 !== fieldsChanges[keyField][key].length && ',' || ''}&nbsp;
                                                        </>
                                                    ))}

                                                </>
                                            ))}
                                        </div>
                                        </>
                                    }
                                    {keyField === 'TextComment' &&
                                        <div className="text-sm flex items-center">
                                            <span>Комментарий:&nbsp;</span><span className="text-[#BA0C2F] line-through">{fieldsChanges[keyField]['old']}</span>&nbsp;<span className="text-[#22AD5C]">{fieldsChanges[keyField]['new']}</span>
                                        </div>
                                    }
                                    {keyField === 'Created' &&
                                        <div className="text-sm flex items-center">
                                            <span>Дата комментария:&nbsp;</span><span className="text-[#BA0C2F] line-through">{fieldsChanges[keyField]['old']}</span>&nbsp;<span className="text-[#22AD5C]">{fieldsChanges[keyField]['new']}</span>
                                        </div>
                                    }
                                    {keyField === 'Description' &&
                                        <div className="text-sm flex flex-col">
                                            <span>Описание:&nbsp;</span><br /><span className="text-[#BA0C2F] line-through" dangerouslySetInnerHTML={{ __html: fieldsChanges[keyField]['old'].replace(/(^|\W)(#[а-я\w][а-я\w-]*)/gi, '<span style="color: rgb(0,98,155)">$&</span>') }} /><br /><span className="text-[#22AD5C]" dangerouslySetInnerHTML={{ __html: fieldsChanges[keyField]['new'].replace(/(^|\W)(#[а-я\w][а-я\w-]*)/gi, '<span style="color: rgb(0,98,155)">$&</span>') }} />
                                        </div>
                                    }
                                    {keyField === 'Status' &&
                                        <div className="text-sm flex items-center">
                                            <span>Статус:&nbsp;</span><span className="text-[#BA0C2F] line-through">{fieldsChanges[keyField]['old']['name']}</span>&nbsp;<span className="text-[#22AD5C]">{fieldsChanges[keyField]['new']['name']}</span>
                                        </div>
                                    }
                                    {keyField === 'Meeting' &&
                                        <div className="text-sm flex items-center">
                                            <span>Совещание:&nbsp;</span><span className="text-[#BA0C2F] line-through">{fieldsChanges[keyField]['old']['name']}</span>&nbsp;<span className="text-[#22AD5C]">{fieldsChanges[keyField]['new']['name']}</span>
                                        </div>
                                    }
                                    {keyField === 'Responsible' &&
                                        <div className="text-sm flex items-center">
                                            <span>Ответственный за пересмотр:&nbsp;</span><span className="text-[#BA0C2F] line-through"><a href={`mailto:${fieldsChanges[keyField]['old'][0]['value']}`}>{fieldsChanges[keyField]['old'][0]['label']}</a></span>&nbsp;<span className="text-[#22AD5C]"><a href={`mailto:${fieldsChanges[keyField]['new'][0]['value']}`}>{fieldsChanges[keyField]['new'][0]['label']}</a></span>
                                        </div >
                                    }
                                    {keyField === 'DateForDone' &&
                                        <div className="text-sm flex items-center">
                                            <span>Срок пересмотра:&nbsp;</span><span className="text-[#BA0C2F] line-through">{moment(fieldsChanges[keyField]['old']['startDate']).format('DD.MM.YYYY')}</span>&nbsp;<span className="text-[#22AD5C]">{moment(fieldsChanges[keyField]['new']['startDate']).isValid() && moment(fieldsChanges[keyField]['new']['startDate']).format('DD.MM.YYYY') || ""}</span>
                                        </div>
                                    }
                                </>
                            ))}
                        </div>
                    }
                </>
            }
        </div>
    );
};

export default HistoryChanges;
